module.exports = __webpack_public_path__ + "static/media/HC-LOGO.bb5292ae.png";